import svgIcons from './images/svgIcons'


const Images = {
  census_brokerdash: require('./images/businessnowdash/census.png'),
  correction_brokerdash: require('./images/businessnowdash/correction.png'),
  invoice_brokerdash: require('./images/businessnowdash/invoice.png'),
  pga_brokerdash: require('./images/pga.svg'),
  ENTRY_NOT_COMPLETED: require('./images/ENTRY_NOT_COMPLETED.svg'),
  DIS_DOCUMENT_REQUIRED: require('./images/DIS_DOCUMENT_REQUIRED.svg'),
  DIS_DOCUMENT_ACCEPTANCE_PENDING: require('./images/DIS_DOCUMENT_ACCEPTANCE_PENDING.svg'),
  ENTRY_NOT_RELEASED: require('./images/ENTRY_NOT_RELEASED.svg'),
  shipments_brokerdash: require('./images/businessnowdash/shipments_circle.png'),
  statement_brokerdash: require('./images/businessnowdash/statement.svg'),
  lvsShipment: require('./images/lvsShipment.svg'),
  shipment_circle: require('./images/shipment_circle.svg'),
  printcopy:require('./images/printcopy.svg'),
  excelcopy:require('./images/excelcopy.svg'),
  thrdIcn :require('./images/thrdIcn.png'),
  INVOICE:require('./images/INVOICE.svg'),
  Arrival:require('./images/Arrival.svg'),
  ops:require('./images/ops.svg'),
  xmtcircle:require('./images/xmt.png'),
  xmt:require('./images/XMT.svg'),
  CRboxKlearviewIcon:require('./images/CRboxKlearviewIcon.svg'),
  ESKlearviewIcon:require('./images/ESKlearviewIcon.svg'),
  allDone: require('./images/LVS_All_Done.svg'),
  ellipsis: require('./images/ellipsis.svg'),
  logout: require('./images/Icon_logout.svg'),
  message: require('./images/Icon_Messages.svg'),
  account: require('./images/Icon_My_Account.svg'),
  search: require('./images/icon_search.svg'),
  OCEAN: require("./images/ship.svg"),
  AIR: require('./images/plane@2x.png'),
  TRUCK:  require('./images/truck.svg'),
  RAIL:  require('./images/train.svg'),
  carrierShip: require('./images/icon_Carrier_Ship.svg'),
  carrierShipBlue: require('./images/icon_Carrier_Ship_Blue.svg'),
  containerPickup: require('./images/building2.svg'),
  portIcon: require('./images/Legenda_port.svg'),
  carrierTruck: require('./images/deliverytruck.png'),
  airplanepicc: require('./images/plane@2x.png'),
  truckccc:  require('./images/truck.svg'),
  trainccc:  require('./images/train.svg'),
  USFlagicoi:   require('./images/flags/USFlagicoi.png'),
  CAFlagicoi:   require('./images/flags/CAFlagicoi.png'),
  GBFlagicoi:   require('./images/flags/UKFlagicoi.png'),
  close: require('./images/icon_close.svg'),
  verified: require('./images/verified.svg'),
  verifiedYellow: require('./images/verified.yellow.svg'),
  file: require('./images/file.svg'),
  info: require('./images/info.svg'),
  sliderArrow: require('./images/Icon_Small_Arrow.svg'),
  addUserButton: require('./images/Add_User.png'),
  usaFlag:require("./images/us_flag.svg"), 
  ukFlag:require("./images/UK_Flag.svg"),
  canadaFlag:require("./images/canada_flag.svg"),
  visa: require('./images/icon-Visa.png'),
  mastercard: require('./images/Icon_Mastercard.png'),
  missingPayment: require('./images/missing-payment-data.png'),
  bank: require('./images/bank.png'),
  knlogonew: require('./images/KlearNowLogo.png'),
  newknlogo: require('./images/newlogo2.png'),
  downArrow: require('./images/down-arrow.svg'),
  userGroup: require("./images/user-group.svg"),
  addDocument: require("./images/add-document.svg"),
  sendPending: require("./images/send-pending.svg"),
  lock: require("./images/locked-padlock.svg"),
  ship: require("./images/ship.svg"),
  qryFuncIcon: require("./images/qryFuncIcon.png"),
  menuIcon: require("./images/menu-icon.svg"),
  qryFuncPlaceholderIcon: require("./images/qryFuncPlaceholderIcon.png"),
  transit: require("./images/transit.svg"),
  noShipments: require("./images/noShipments.svg"),
  svgIcons
}

export default Images;
